var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1965_11400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1965_11400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 15.7292C3.98607 15.7292 3.8369 15.6667 3.71913 15.5417C3.60079 15.4167 3.54163 15.2708 3.54163 15.1042C3.54163 14.9236 3.60079 14.7742 3.71913 14.6558C3.8369 14.5381 3.98607 14.4792 4.16663 14.4792H5.20829V8.4375C5.20829 7.32639 5.55552 6.32972 6.24996 5.4475C6.9444 4.56583 7.84718 4 8.95829 3.75V3.16667C8.95829 2.875 9.05913 2.62833 9.26079 2.42667C9.4619 2.22556 9.70829 2.125 9.99996 2.125C10.2916 2.125 10.538 2.22556 10.7391 2.42667C10.9408 2.62833 11.0416 2.875 11.0416 3.16667V3.75C12.1527 4 13.0555 4.56583 13.75 5.4475C14.4444 6.32972 14.7916 7.32639 14.7916 8.4375V14.4792H15.8333C16.0138 14.4792 16.1633 14.5381 16.2816 14.6558C16.3994 14.7742 16.4583 14.9236 16.4583 15.1042C16.4583 15.2708 16.3994 15.4167 16.2816 15.5417C16.1633 15.6667 16.0138 15.7292 15.8333 15.7292H4.16663ZM9.99996 18.1667C9.58329 18.1667 9.22913 18.0208 8.93746 17.7292C8.64579 17.4375 8.49996 17.0833 8.49996 16.6667H11.5C11.5 17.0833 11.3541 17.4375 11.0625 17.7292C10.7708 18.0208 10.4166 18.1667 9.99996 18.1667ZM6.45829 14.4792H13.5416V8.4375C13.5416 7.45139 13.1944 6.61444 12.5 5.92667C11.8055 5.23944 10.9722 4.89583 9.99996 4.89583C9.02774 4.89583 8.1944 5.23944 7.49996 5.92667C6.80552 6.61444 6.45829 7.45139 6.45829 8.4375V14.4792Z",
    fill: "#343434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.293321519746a949a416170e241c9404.svg";
export { ForwardRef as ReactComponent };